import { IMiddleware } from '@opengov/compose-app/types';

import { reportLocaleText } from '../locale';
import { selectIsReportDimensional, selectIsReportMultiDataset } from '../report/selectors';

import { reportQueryEffects } from './effects/reportQueryEffects';
import {
  reportConfigurationActions,
  reportConfigurationSelector,
  reportConfigurationsMatchForAccountSummary,
  reportConfigurationsMatchForDimensionalQueries,
  reportConfigurationsMatchForQueries
} from './state';
import { MuiToastTypes } from '../helpers/utils';
import { reportActionCreators } from '../report/state';

// This middleware watches for reportConfigurationActions that mutate enough to need a new query to run

const reportConfigurationActionTypes = Object.keys(reportConfigurationActions)
  .filter((a) => a !== 'setReportConfigurationStatus' && a !== 'updateReportConfiguration' && a !== 'resetState')
  .map((a) => reportConfigurationActions[a].actionType);

export const queryMiddleware =
  (queryEffect: typeof reportQueryEffects.query): IMiddleware =>
  (api) =>
  (next) =>
  (action) => {
    if (reportConfigurationActionTypes.some((a) => a === action.type)) {
      const currentRC = reportConfigurationSelector(api.getState() as any).currentReportConfiguration;
      const nextResult = next(action);
      const newRC = reportConfigurationSelector(api.getState() as any).currentReportConfiguration;
      const isDimensional = selectIsReportDimensional(api.getState() as any);
      const isMultiDataset = selectIsReportMultiDataset(api.getState() as any);
      const refresh =
        action.type.endsWith('refreshReportConfiguration') ||
        action.type.endsWith('setCurrentReportConfigurationAndForceRefresh');

      if (
        refresh ||
        !currentRC ||
        (isMultiDataset && !reportConfigurationsMatchForAccountSummary(currentRC, newRC)) ||
        (isDimensional && !reportConfigurationsMatchForDimensionalQueries(currentRC, newRC)) ||
        !reportConfigurationsMatchForQueries(currentRC, newRC)
      ) {
        queryEffect(newRC).catch((e) => {
          const text = reportLocaleText(api.getState() as any);

          reportActionCreators.toggleMuiToast({
            type: MuiToastTypes.FAILURE,
            headerText: text.query.failure.headerText,
            bodyText: text.query.failure.bodyText,
            dataTest: `toast-load-report-failure`
          });

          throw e;
        });
      }

      return nextResult;
    }

    return next(action);
  };
